import { Component, OnInit, Input } from '@angular/core';
import { NavController, ModalController, NavParams } from '@ionic/angular';
import { tap, switchMap } from 'rxjs/operators';
import { HttpServerService } from '../HttpServer/HttpServer'
import { AuthService } from '../Login/Auth'
import { GlobalSettingsService } from '../GlobalSettings/GlobalSettings';

@Component({
    selector: 'owners',
    templateUrl: 'Owners.html'
})
export class OwnersPage implements OnInit {

    colUser: number = 0;
    colAccess: number = 1;

    colName: number = 0;
    colEmail: number = 1;
    colInit: number = 2;
    colAccess2: number = 3;

    runOnProvServer: boolean = false;
    resourceName: string = "";
    resourceType: string = "";
    tableName: string;
    Id: number;
    users: any;
    allAccessItem: any = ['Everyone', '*', 0, 0];
    fromEveryone: number = 100;

    constructor(public navCtrl: NavController, public viewCtrl: ModalController, public params: NavParams,
        public http: HttpServerService, public auth: AuthService,public globalSettings: GlobalSettingsService) {

        if (params.get('runOnProvServer'))
            this.runOnProvServer = params.get('runOnProvServer');
        this.resourceName = params.get('resourceName');
        this.resourceType = params.get('resourceType');
        this.tableName = params.get('tableName');
        this.Id = params.get('Id');
    }

    ngOnInit() {
        return this.http.globalPostType("Admin.Licenses", "LicenseUserList", { OrderC: [0], OrderT: ['ASC'], ExcludeOwner: false, Key:this.globalSettings.get("license") })
            .pipe(
                switchMap((result) => {
                    this.users = result;
                    return this.listResourceOwners();
                }),
                tap((owners) => {

                    let all = owners.find((item) => { return item[this.colUser] === '*'; });
                    if (all) {
                        this.allAccessItem[this.colAccess2] = all[this.colAccess];
                        this.allAccessItem[this.colInit] = this.allAccessItem[this.colAccess2];
                    }

                    for (let user of this.users) {
                        user[this.colAccess2] = this.fromEveryone; //this.allAccessItem[this.colInit];
                        for (let owner of owners) {
                            if (user[this.colEmail] == owner[this.colUser]) {
                                user[this.colAccess2] = owner[this.colAccess];
                                break;
                            }
                        }
                        user[this.colInit] = user[this.colAccess2];
                    }
                })
            )
            .subscribe(() => {
            });
    }

    roleCompare(e1: any, e2: any): boolean {
        return e1 == e2;
    }

    onAllAccessChange(event) {
        /*for (let user of this.users) {
            if (user[this.colAccess2] == this.allAccessItem[this.colAccess2])
                user[this.colAccess2] = Number(event);
        }*/
        this.allAccessItem[this.colAccess2] = Number(event.detail.value);
    }

    cancel() {
        this.viewCtrl.dismiss();
    }

    done() {

        let add = [];
        let access = [];
        let remove = [];

        if (this.allAccessItem[this.colAccess2] == 0) {
            remove.push(this.allAccessItem[this.colEmail]);
        }
        else if (this.allAccessItem[this.colInit] != this.allAccessItem[this.colAccess2]) {
            add.push(this.allAccessItem[this.colEmail]);
            access.push(Number(this.allAccessItem[this.colAccess2]));
        }

        for (let user of this.users) {
            if (user[this.colAccess2] == this.fromEveryone) { //this.allAccessItem[this.colAccess2]) {
                remove.push(user[this.colEmail]);
            }
            else if (user[this.colInit] != user[this.colAccess2]) {
                add.push(user[this.colEmail]);
                access.push(Number(user[this.colAccess2]));
            }
        }

        /*
        for (let user of this.users) {
            if (user[this.colInit] && !user[this.colAccess2]) {
                remove.push(user[this.colEmail]);
            }
            else if (user[this.colInit] != user[this.colAccess2]) {
                add.push(user[this.colEmail]);
                access.push(Number(user[this.colAccess2]));
            }            
        }
        */

        this.addResourceOwners(add, access)
            .pipe(
                switchMap(() => this.removeResourceOwners(remove))
            )
            .subscribe(() => { }
                , () => { this.viewCtrl.dismiss(); }
                , () => { this.viewCtrl.dismiss(); });
    }

    listResourceOwners() {
        if (this.runOnProvServer)
            return this.http.globalPostType("Admin.Users", "ListResourceOwners", { TableName: this.tableName, Id: this.Id, ProvisionServer: true });
        return this.http.postType("Admin.Users", "ListResourceOwners", { TableName: this.tableName, Id: this.Id, ProvisionServer: false });
    }

    addResourceOwners(add, access) {
        if (this.runOnProvServer)
            return this.http.globalPostType("Admin.Users", "AddResourceOwners", { TableName: this.tableName, Id: this.Id, Usernames: add, Access: access, ProvisionServer: true });
        return this.http.postType("Admin.Users", "AddResourceOwners", { TableName: this.tableName, Id: this.Id, Usernames: add, Access: access, ProvisionServer: false });
    }

    removeResourceOwners(remove) {
        if (this.runOnProvServer)
            return this.http.globalPostType("Admin.Users", "RemoveResourceOwners", { TableName: this.tableName, Id: this.Id, Usernames: remove, ProvisionServer: true });
        return this.http.postType("Admin.Users", "RemoveResourceOwners", { TableName: this.tableName, Id: this.Id, Usernames: remove, ProvisionServer: false });
    }

    formatUser(user) {
        return {
            header: user[this.colName],
            subHeader: user[this.colEmail]
        };
    }

    onAccessChange(user, event) {
        if (Number(event) != 1)
            return;

        for (let item of this.users) {
            if (Number(item[this.colAccess2]) == 1 && item[this.colEmail] != user[this.colEmail])
                item[this.colAccess2] = 2;
        }
    }

    isOwner(user) {
        return Number(user[this.colAccess2]) == 1;
    }

    localUserIsOwner(user) {
        let findfilter = this.users.find((item) => { return item[this.colEmail] === this.auth.currentUser.getEmail(); });
        if (!findfilter)
            return false;

        if (findfilter[this.colInit] && Number(findfilter[this.colInit]) == 1)
            return true;

        return false;
    }
}
